module.exports = __webpack_public_path__ + "src/fonts/KaTeX_Caligraphic-Regular.woff";